function legacyLooksPaid(member) {
  if (typeof member?.fee_paid === "boolean") {
    return member.fee_paid;
  }
  const inv = member?.invoice;
  if (!inv || inv.payment_status === "Cancelled" || inv.payment_status === "Overdue") {
    return false;
  }
  if (inv.payment_status === "Paid" || inv.is_paid === true) {
    return true;
  }
  if (inv._id && Number(inv.pending_amount ?? 1) <= 0) {
    return true;
  }
  return member?.is_due === false;
}

/**
 * Members roster fee chip.
 * Inactive members are never shown as fee paid: their latest voucher has expired
 * or the membership term has ended. Open unpaid invoices stay "Fee due".
 */
export function memberFeeChip(member) {
  const invoiceStatus = member?.invoice?.payment_status;
  const voucherInactive = Boolean(member?.voucher?._id) && member.voucher.is_active === false;
  const expired =
    member?.fee_status === "expired" ||
    invoiceStatus === "Overdue" ||
    voucherInactive ||
    (member?.is_active === false && legacyLooksPaid(member));

  if (expired) {
    return { label: "Voucher expired", tone: "danger", paid: false };
  }

  if (member?.fee_status === "paid") {
    return { label: "Fee paid", tone: "success", paid: true };
  }
  if (member?.fee_status === "due") {
    return { label: "Fee due", tone: "warning", paid: false };
  }

  const paid = legacyLooksPaid(member) && member?.is_active !== false;
  return {
    label: paid ? "Fee paid" : "Fee due",
    tone: paid ? "success" : "warning",
    paid,
  };
}
